module.exports = __webpack_public_path__ + "img/enter.e99a4c01.svg";